import React from 'react';
import { Box, Typography, Chip, IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const CategoryList = ({ categoryNames, onEdit, onDelete }) => (
  <>
    <Typography variant="h6" sx={{ mt: 2 }}>Category Names:</Typography>
    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mt: 2 }}>
      {categoryNames.map((item, index) => (
        <Box
          key={index}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: 1,
            border: '2px solid #1976d2',
            borderRadius: 1,
          }}
        >
          <Chip
            label={item.value}
            sx={{ mr: 1, backgroundColor: '#1976d2', color: 'white', fontWeight: 'bold' }}
          />
          <Box>
            <IconButton onClick={() => onEdit(item.id, item.value,item.slug,item.shortCode)} color="primary" size="small">
              <EditIcon />
            </IconButton>
            <IconButton onClick={() => onDelete(item.id)} color="secondary" size="small">
              <DeleteIcon />
            </IconButton>
          </Box>
        </Box>
      ))}
    </Box>
  </>
);

export default CategoryList;
